export enum TScheduleStatusEnum {
	SCHEDULED = "AGENDADO",
	CITIZEN_PRESENT = "CIDADAO_PRESENTE_NA_UNIDADE",
	DID_NOT_SHOW_UP = "NAO_COMPARECEU",
	DID_NOT_WAIT = "NAO_AGUARDOU",
	CANCELED = "CANCELADO",
	ATTENDED = "ATENDIMENTO_REALIZADO",
	EXCLUDED = "EXCLUIDO",
}
